// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q-field--auto-height.q-field--labeled .q-field__control-container{padding-top:4px!important}.q-field__bottom{margin-bottom:18px}.q-field--labeled .q-field__native{padding-top:16px!important}.no-percentage{margin-left:-8px}.wrapper{justify-content:space-between}.input-wrap,.wrapper{display:flex}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
